exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#consecutive-lessons[data-v-8873fb54]{padding:5px}", ""]);

// exports
